import {Navbar,Footer} from '../components';
import {useParams} from 'react-router-dom';
import {useState,useEffect} from 'react';
import axios from "axios";
import configData from "../config.json";
import * as Icon from 'react-bootstrap-icons';
import { Modal, Button, Form, Tabs, Tab } from "react-bootstrap";

function OverheadSummary(){
    if(localStorage.getItem('branchID')===null){
        window.location.replace('/');
    }

    const [expCompList,setExpCompList]=useState([]);
    const [filterExpCompList,setFilterExpCompList]=useState([]);
    const [overheadSummary,setOverheadSummary]=useState([]);
    const [inputData,setInputData]=useState([]);  
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true); 

    useEffect(() => {
        const getOverheadList = async () => {
            const currentYear = new Date().getFullYear();
            const response=await axios.get(configData.SERVER_URL+`/showOverheadDetails/${localStorage.getItem('branchID')}/${currentYear}`);
            setOverheadSummary(await response.data);

            const res=await axios.get(configData.SERVER_URL+`/expCompDetails`);
            setExpCompList(await res.data);
    };
    getOverheadList();
    
    }, []);

    async function setFilterData(id){        
        // const updatedList = expCompList.filter((exp) => exp.subOverheadID.includes(subheadID));
        // setFilterExpCompList(updatedList);
        const res=await axios.get(configData.SERVER_URL+`/expCompDetails/${id}`);
        setFilterExpCompList(await res.data);
    }

    return(
        <>
        <div className='container'>
        <Navbar />

        <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title>Exp. Compements details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <div className="table-responsive">
                        <table class="table table-success table-hover table-bordered">
                            <thead>
                            <tr>
                                <th>Sl</th>
                                <th>Description</th>
                                <th>Estimated Exp.</th>
                                <th>Revised Exp.</th>
                                <th>Actual Exp.</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                            filterExpCompList && filterExpCompList.length>0 && filterExpCompList.map((data,index)=>
                            <tr align="right" key={data.id} >
                                <td align="left">{index+1}</td> 
                                <td align="left">{data.description}</td>  
                                <td align="left">{data.estimatedExp}</td>
                                <td align="left">{data.revisedExp}</td>
                                <td align="left">{data.actualExp}</td> 
                            </tr>
                            )}   
                            </tbody>
                        </table>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

        <div className='card'>
            <div className='card-body'>
                <div className='card-header bg-info'>Overhead details</div>
                <div className="table-responsive">
                    <table class="table table-success table-hover table-bordered">
                        <thead>
                        <tr>
                            <th>SL No.</th>
                            <th>Head</th>
                            <th>Sub-Head</th>
                            <th>Estimated Exp.</th>
                            <th>Revised Exp.</th>
                            <th>Actual Exp.</th>

                            <th>Estimated Exp.</th>
                            <th>Revised Exp.</th>
                            <th>Actual Exp.</th>

                            <th>Estimated Exp.</th>
                            <th>Revised Exp.</th>
                            <th>Actual Exp.</th>
                            <th></th>
                        </tr>
                        </thead>
                    <tbody>
                    {
                    overheadSummary && overheadSummary.length>0 && overheadSummary.map((data,index)=>
                        <tr align="right" key={data.id} >
                            <td align="left">{index+1}</td>   
                            <td align="left">{data.overheadName}</td>
                            <td align="left"onClick={() => {handleShow();setFilterData(data.subOverheadID);}}>{data.subOverheadName}</td>
                            <td align="right">{data.estimatedExp}</td>
                            <td align="right">{data.revisedExp}</td>
                            <td align="right">{data.actualExp}</td>

                            <td align="right">{data.estimatedExp_1}</td>
                            <td align="right">{data.revisedExp_1}</td>
                            <td align="right">{data.actualExp_1}</td>

                            <td align="right">{data.estimatedExp_2}</td>
                            <td align="right">{data.revisedExp_2}</td>
                            <td align="right">{data.actualExp_2}</td>
                            <td><button className='btn btn-info'><Icon.ArrowRight onClick={() => {}}/></button></td>
                        </tr>
                    )}
                    </tbody>
                    </table>
                </div>
            </div>
        </div>    
        <Footer/>
        </div>
        </>
    )
}

export default OverheadSummary;